import * as React from 'react';
import { connect } from 'react-redux';
import {Col, Form, Row} from 'react-bootstrap';
import FaPhone from 'react-icons/fa/phone';
import { flow, forEach, size } from 'lodash';
import FaEnvelop from 'react-icons/fa/envelope';
import { IStore } from '../../../../redux/IStore';
import {IAuthActions} from '../../../../services/auth/reducer';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import {ICompleteData, IQuoteActions} from '../../../../services/quote/models';
import { IProduct, ICustomer, IPremium, IQuotes } from '../../../../data/api/models';
import { IBrandingState, II18nMessages } from '../../../../services/branding/models';
import { Link } from 'react-router-dom';

interface ICompleteProps extends InjectedFormProps {
  quotes: IQuotes;
  premium: IPremium;
  product: IProduct;
  renewal: boolean;
  i18n: II18nMessages;
  customer: ICustomer;
  data: ICompleteData;
  branding: IBrandingState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
    push(path: string);
    auth: IAuthActions;
  };
}

interface ICompleteState {
  polling: boolean;
  pollId?: number;
}

class IComplete extends React.Component<ICompleteProps, ICompleteState> {
  public state = {
    polling: false,
    pollId: null,
  };

  public componentDidMount() {
    // Block going back
    const { history, location } = window;
    history.pushState(null, null, location.href);
    window.onpopstate = (event) => {
      event.preventDefault();
      history.go(1);
    };
  }

  public componentWillUnmount() {
    if (this.state.pollId) {
      // window.clearTimeout(this.state.pollId);
    }
  }

  private renderCompleteMessage = () => {
    const { renewal } = this.props;

    return (
      <div>
        <div>
          {renewal ? (
            <p>Vous avez finalisé le renouvellement de votre contrat d’assurance.</p>
          ) : (
            <p>Vous avez finalisé la souscription de votre contrat d’assurance.</p>
          )}
          <p>Nous vous remercions de votre confiance.</p>
          <p>Vous pouvez télécharger vos documents contractuels ci-dessous.</p>
          {this.showDocuments()}
          <p>Vous pourrez accéder à tout moment à vos documents en créant votre espace personnel</p>
        </div>
      </div>
    );
  }

  private showDocuments = () => {
    const { data } = this.props;

    if (! data.documents.documents) {
      return null;
    }

    const documents = [
      {
        displayName: 'Attestation d\'assurance',
        filePath: data.documents.documents['Attestation d\'assurance'],
      },
      {
        displayName: 'Conditions Particulières',
        filePath: data.documents.documents['Conditions Particulières'],
      },
      {
        displayName: 'Conditions Générales',
        filePath: data.documents.documents['Conditions Générales'],
      },
      {
        displayName: 'Conventions Spéciales et ses Annexes',
        filePath: data.documents.documents['Conventions Spéciales et ses Annexes'],
      },
      {
        displayName: 'Quittance d\'assurance',
        filePath: data.documents.documents['Quittance d\'assurance'],
      },
    ];

    return (
      <Row className={'documents'}>
        <Col sm={12}>
          {documents.map((document, index) => {
            return (
              <a
                key={index}
                className="btn-secondary btn red"
                href={document.filePath}
                target="_blank"
              >
                {document.displayName}
              </a>
            );
          })}
        </Col>
      </Row>
    );
  }

  private renderTrackingItems = () => {
    const { branding, premium, data } = this.props;

    const items = [];

    if (branding.aggregatorTracking.type === 'cyti') {
      const params = branding.aggregatorTracking.cyti;
      const cytiUrl = branding.aggregatorTracking.cyti.url + '/track/confirm';

      items.push(
        <img
          key={0}
          // tslint:disable-next-line:max-line-length
          src={`${cytiUrl}?cref=${params.cref}&policyreference=${data.policy_number}&premium=${premium.gross}&t=${params.token}`}
          height="0"
          width="0"
        />,
      );
    }

    if (branding.aggregatorTracking.type === 'idol') {
      const params = branding.aggregatorTracking.idol;
      const url = 'https://www.quote-link.net/xml/travelquotes_wl/salestracking/travelquotes_sale_confirmation.cfm';

      items.push(
        <img
          key={0}
          src={`${url}?ref=${params.reference}&fullprem=${premium.gross}`}
          height="0"
          width="0"
        />,
      );
    }

    return items;
  }

  private pollDocuments = () => {
    const { data, actions } = this.props;

    actions.quote.pollPolicyDocuments(data.documents_poll_token).then(({ documents }) => {
      if (documents.length === 0) {
        this.setState({
          pollId: window.setTimeout(this.pollDocuments, 2000),
        });

        return;
      }

      actions.quote.completeDocuments({ documents });

      this.setState({
        polling: false,
        pollId: null,
      });
    });
  }

  public componentWillMount() {
    const { data } = this.props;

    if (size(data.documents.documents) > 0) {
      return;
    }

    if (this.state.polling) {
      return;
    }

    this.setState({
      polling: true,
    });

    setTimeout(this.pollDocuments, 2000);
  }

  public render() {
    const { data, auth, quotes } = this.props;
    const policyNumber = data.policy_number && data.policy_number;

    const customer = quotes.customer;
    const customerStatus = customer ? customer[0].status : '';
    // const hasCustomer = customer.length > 0;

    return (
      <Form>
        <div className="steps-container">
          <h3>Finalisation du contrat</h3>
          <div className="policy-number-container">
            Votre numéro de police est: <span className="policy-number">{policyNumber}</span>
            <div className="clearfix" />
          </div>
          {this.renderCompleteMessage()}
          {this.renderTrackingItems()}
          {customerStatus === 'not applicable' ? (
            <div className="section margin-top create-account">
              <p>
                You will receive an email shortly with details on how to access your account and policy documents.
              </p>
            </div>
          ) : (
            <div className="margin-top create-account">
              <div className="btn-bar">
                {auth.isAuthenticated ? (
                  <Link
                    to="/auth/login"
                    target={auth.isAuthenticated ? '_self' : '_blank'}
                    className="btn-next btn btn-secondary red pull-left"
                  >
                    Mon compte
                  </Link>
                ) : (
                  <Link
                    to="/auth/create-an-account"
                    target={'_blank'}
                    className="btn-next btn btn-secondary red pull-left"
                  >
                    Créer votre espace personnel
                  </Link>
                )}

              </div>
            </div>
          )}
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const { quotes } = state.quote;

      let premium: IPremium = null;

      const values = selector(
        state,
        'tripType',
        'schemeId',
        'quoteReference',
      );

      if (state.quote.quotes) {
        forEach(state.quote.quotes, (tripTypes, level) => {
          forEach(tripTypes, (quotedPremium: IPremium) => {
            if (!quotedPremium) {
              return null;
            }

            if (quotedPremium.scheme.id === values.schemeId) {
              premium = quotedPremium;
            }
          });
        });
      }

      return {
        quotes,
        premium,
        branding: state.branding,
        data: state.quote.complete,
      };
    },
  ),
])(IComplete);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Complete/index.tsx